import React, { useEffect, useState } from 'react';
import Header from '../../../Header';
import Footer from '../../Footer';
import '../../css/presale.css'
// import Stage1 from '../../Presale/Stage1'
import Stage2 from '../../Presale/Stage2'
import Presalesecondstage1 from '../Stage1';
import AccordionBox from '../../Presale/Accordion'
import Banner from '../../Presale/Banner'
import Rangeslider from '../../Presale/Rangeslider'
import { Fade, Zoom } from 'react-reveal';
import Community from '../../../community';



import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { getInfiTokenPrice, getPresaleStatistics, getUsdtAddress } from '../../../../services/apiServices';
import { Link } from 'react-router-dom';
import config from '../../../../config';
;



const Presalesecond = () => {
    const [openBuyForm, setOpenBuyForm] = useState(false);
    const [connectWalletNow, setconnectWalletNow] = useState(false);
    const [InfiTokenPrice, setInfiTokenPrice] = useState(0);
    const [UsdtContract, setUsdtContract] = useState("")
    const [presaleContract, setpresaleContract] = useState("");
    const [totalSold, setTotalSold] = useState(0);

    useEffect(() => {
        getPrice()
        getUsdtContract()
    }, [])
    const getPrice = async () => {
        const res = await getInfiTokenPrice();
        const resStatistics = await getPresaleStatistics();
        if (res.data?.status) {
            setInfiTokenPrice(parseFloat(res.data.data.infiprice));
            setpresaleContract(resStatistics.data.data.PreSaleAddress || "")
            setTotalSold(resStatistics.data.data.SoldOutToken || 0)
        }
    }
    const getUsdtContract = async () => {
        const res = await getUsdtAddress();
        if (res.data?.status) {
            setUsdtContract(res.data.data.usdtAddress);
        }
    }
    return (
        <>
            <Header showBuyBtn={true} setOpenBuyForm={setOpenBuyForm} connectWalletNow={connectWalletNow} setconnectWalletNow={setconnectWalletNow} />

            {/* <div className="presale pt-5 pb-4">

                <div className='bg_presale'>
                    <img src='assets/images/presale/presaleback.png' width={`100%`} />

                </div>
                <div className='shapeEllipse'>
                    <img src='assets/images/shape1.svg' className='shape shape1' />
                    <img src='assets/images/shape2.svg' className='shape shape2' />
                </div>
               
            </div> */}

            <Banner />

            <section className='stage pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center mobile-row-reverse' >
                        <Col lg={6} className='pe-5'>
                            <Presalesecondstage1
                                openBuyForm={openBuyForm}
                                setOpenBuyForm={setOpenBuyForm}
                                setconnectWalletNow={setconnectWalletNow}
                                InfiTokenPrice={InfiTokenPrice}
                                UsdtContract={UsdtContract}
                                presaleContract={presaleContract}
                            />
                        </Col>
                        <Col lg={6} className=''>
                            <div className='ps-5'>
                                <img src='assets/images/presale/stageImg1.png' className='nftImg' />
                            </div>
                        </Col>
                    </Row>

                </Container>
            </section>



            <section className='stage pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center' >
                        <Col lg={6} className=''>
                            <div className='pe-5'>
                                <img src='assets/images/presale/stageImg2.png' className='nftImg' />
                            </div>
                        </Col>

                        <Col lg={6} className='text-right'>
                            {/* <Stage2 /> */}
                            <Presalesecondstage1
                                openBuyForm={openBuyForm}
                                setOpenBuyForm={setOpenBuyForm}
                                setconnectWalletNow={setconnectWalletNow}
                                InfiTokenPrice={InfiTokenPrice}
                                UsdtContract={UsdtContract}
                                presaleContract={presaleContract}
                            />
                        </Col>

                    </Row>

                </Container>
            </section>


            <section className='stage pt-5 pb-5 mb-5'>
                <Container>
                    <Row className='justify-content-center mobile-row-reverse' >

                        <Col lg={7} className='text-left'>
                            <h1 className='text-blue text-uppercase text-gradient mb-3 fw-bold'>FAQ</h1>
                            <AccordionBox />
                        </Col>
                        <Col lg={5} className=''>
                            <div className='faqImage p-5'>
                                <img src='assets/images/presale/faq.svg' />
                            </div>
                        </Col>
                    </Row>

                </Container>
            </section>


            <Community />


            <Footer />
        </>
    )
}

export default Presalesecond;
